export const enum EnumAcaoLeituraRfid {
    DESATIVAR,
    ATIVAR
}